// Localization config (Switzerland)

import { Localization } from '../../../shared/Localization';

import de from '../../generic/l10n/messages_de';
import fr from '../../generic/l10n/messages_fr_ch';
import en from '../../generic/l10n/messages_en';

const localization = new Localization('default_ch', de, [de, fr, en]);

export default localization;
